import { useState } from 'react';
import { ArrowUpRight, Mail } from 'lucide-react';
import { useProfile } from '../hooks/use-public';

export default function Footer() {
  const { data: profile } = useProfile();
  const [year] = useState(() => new Date().getFullYear());

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <p className="footer-name">铁头功的博客</p>
          <p className="footer-tagline">{profile?.tagline ?? '记录工程实践与技术思考'}</p>
        </div>

        <div className="footer-contact">
          {profile?.email && (
            <a href={`mailto:${profile.email}`} className="footer-contact-item">
              <Mail size={15} aria-hidden="true" />
              {profile.email}
            </a>
          )}
          {profile?.socials?.map((social) => (
            <a
              key={social.label}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-item"
            >
              {social.label}
              <ArrowUpRight size={13} aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>

      <div className="container footer-meta">
        <span>© {year} 铁头功的博客 · 保留所有权利</span>
        {/* ICP 备案号将在备案完成后补充于此 */}
      </div>
    </footer>
  );
}
